export const star = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2861 5.65039C11.0146 7.61897 12.5148 9.19749 14.4297 10.0273L14.8184 10.1826L15.5908 10.4688L14.8184 10.7549C12.8498 11.4834 11.2713 12.9835 10.4414 14.8984L10.2861 15.2871L10 16.0596L9.71387 15.2871C8.98538 13.3185 7.48524 11.74 5.57031 10.9102L5.18164 10.7549L4.4082 10.4688L5.18164 10.1826C7.15022 9.45413 8.72874 7.95399 9.55859 6.03906L9.71387 5.65039L10 4.87695L10.2861 5.65039Z"
        fill="#FFC400"
        stroke="url(#paint0_linear_923_10044)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_923_10044"
          x1="10"
          y1="3.4375"
          x2="10"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.8" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
